<template>
	<NavSidebarLayout
		:show-left-sidebar="showLeftSidebar"
		:scrollable="false"
	>
		<header class="page-with-title__header">
			<div class="page-with-title__title-row">
				<div class="page-with-title__title-position">
					<MobileMenuIcon
						v-if="showMobileMenuIcon"
						class="page-with-title__mobile-menu-icon"
						@click="onMobileMenuIconClicked"
					/>
					<div class="page-with-title__title-layout">
						<div class="page-with-title__title-text">
							<slot name="title" />
						</div>
					</div>
				</div>
			</div>
		</header>
		<main class="page-with-title__tab-container">
			<router-view v-bind="$attrs" />
		</main>
	</NavSidebarLayout>
</template>

<script>
import ScreenSizeDetector from "screen-size-detector";
import { foundation } from "@teaming/slice-engine";
import MobileMenuIcon from "../components/icons/MobileMenuIcon";

/** @deprecated */
export default {
	name: "PageWithTitle",

	components: {
		MobileMenuIcon,
	},

	inject: [ "userProfile", ],

	data() {
		return {
			screenWidth: window.innerWidth,
		};
	},

	props: {
		showLeftSidebar: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		showMobileMenuIcon() {
			return foundation().config.permitMobileMenu;
		},
	},

	methods: {
		onMobileMenuIconClicked( e ) {
			e.preventDefault();
			e.stopPropagation();
			foundation().sidebar.open();
		},
	},

	created() {
		this.screen = new ScreenSizeDetector( {
			onWidthChange: () => {
				this.screenWidth = this.screen.width;
			},
		} );
	},

	unmounted() {
		this.screen.removeMainCallback( "widthchange" );
		this.screen = undefined;
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>

<style lang="scss" scoped>
.page-with-title__header {
	width: 100%;
	border-bottom: 0.0625rem solid $page-with-title-header-border-color;
	display: flex;
	flex-direction: column;
}

.page-with-title__tab-container {
	@include auto-y-scroll();
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}

.page-with-title__title-row {
	padding: 1.125rem 0 1.125rem 0;
	@include font-and-line-for(2);
	color: $page-with-title-font-color;
	overflow-y: hidden;

	@include for-size-and-larger('sm') {
		padding: 1.625rem 1rem 1.625rem 2rem;
	}
}

.page-with-title__title-position {
	position: relative;
}

.page-with-title__title-layout {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;

	@include for-size-and-larger('md') {
		gap: 0.5rem;
		justify-content: flex-start;
	}

	@include for-size('xs') {
		margin-left: 2.5rem;
	}
}

.page-with-title__title-text {
	font-weight: bold;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	@include font-and-line-for(1);

	@include for-size('sm') {
		@include font-and-line-for(2);
	}
}

.page-with-title__mobile-menu-icon {
	margin: 0 0 0 1rem;
	padding: 0;

	position: absolute;
	top: 0;
	left: 0;

	@include for-size('md') {
		display: none;
	}
}

</style>
